import { store } from "../../utils/index";
import moment from "moment";
import { process } from "@progress/kendo-data-query";
import {
    initConstructTableCols,
    initConstructTableState,
} from "../initialStates";
import { initRegionalSettings } from "../../pages/Settings/SettingsHelpers";

const user = store.get("userInfo");

export const initialState = {
    userInfo: user
        ? {
              ...user,
              custId: parseInt(user.custId),
          }
        : null,
    trialStartDate: store.get("trialStartDate"),
    patientList: [], // list of all patients for a particular date
    communicationTable: [], // list of patient table in COMMUNICATION page
    practiceList: store.get("practiceList") || [
        {
            practiceLogoURL: "",
            practiceID: "",
            practiceName: "",
        },
    ],
    activeItem: store.get("activeItem") || {
        type: "solo",
        name: "",
        groupId: "",
        items: [],
    },
    scoresEnabled: [],

    // construct table data
    constructTableData: process([], initConstructTableState),
    constructTableDate:
        store.get("constructTableDate") ||
        moment(new Date()).format("YYYY-MM-DD"),
    constructTableState: initConstructTableState,
    constructTableColumns: store.get("constructTableColumns")
        ? store.get("constructTableColumns")
        : initConstructTableCols,
    numOfCols: store.get("numOfCols") ? store.get("numOfCols") : 10,

    // date,time, number, currency format
    regionalSettings: store.get("regionalSettings")
        ? store.get("regionalSettings")
        : initRegionalSettings,
    sikkaAdmin: store.get("sikkaAdmin"),
};

export const dataReducer = (state = initialState, action) => {
    const { type, data } = action;
    switch (type) {
        case "UPDATE_PRACTICE_LOGO_URL": {
            const { practiceIndex, logoURL } = data;
            const updatedPracticeList = [...state.practiceList];
            if (
                practiceIndex >= 0 &&
                practiceIndex < updatedPracticeList.length
            ) {
                updatedPracticeList[practiceIndex] = {
                    ...updatedPracticeList[practiceIndex],
                    practiceLogoURL: logoURL,
                };
            }

            return {
                ...state,
                practiceList: updatedPracticeList,
            };
        }
        case "UPDATE_PRACTICE_LIST": {
            const { practiceIndex, updatedPractice } = data;
            const updatedPracticeList = [...state.practiceList];
            if (
                practiceIndex >= 0 &&
                practiceIndex < updatedPracticeList.length
            ) {
                updatedPracticeList[practiceIndex] = updatedPractice;
            }
            return {
                ...state,
                practiceList: updatedPracticeList,
            };
        }

        default:
            return {
                ...state,
                [type]: data,
            };
    }
};
